<script lang="ts" setup>
import { Link } from '~/types'

withDefaults(
  defineProps<{
    items: {
      id: number | string
      link: Link
    }[]
    animate?: boolean
  }>(),
  {
    animate: true,
  },
)
</script>
<template>
  <ul v-animate="animate && { cluster: 'true' }" class="link-list cul">
    <li v-for="item in items" :key="item.id" v-animate="animate && { animation: 'vertical-reveal' }" role="none">
      <NuxtLink
        class="link text-xsmall"
        :to="item.link.url"
        tabindex="0"
        v-bind="{
          ...(item.link.target && { target: item.link.target }),
          ...(item.link.target && { 'aria-label': `${item.link.text} (opens in new window)` }),
        }"
      >
        {{ item.link.text }}
        <div class="icons" aria-hidden="true">
          <div class="slider">
            <div class="icon">
              <Icon name="mini-arrow-link" />
            </div>
            <div class="icon">
              <Icon name="link-arrow" />
            </div>
          </div>
        </div>
      </NuxtLink>
    </li>
  </ul>
</template>
<style scoped lang="scss">
.link {
  --width-icon: 24px;
  --translate: calc(-1 * var(--width-icon));
  position: relative;
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;

  padding-block: 12px;

  font-weight: 500;
  color: var(--c-text-medium);
  border-bottom: 1px solid var(--c-line-light);

  @include transitions(color);
  @include hover {
    color: var(--c-blue-rollover);
    --translate: 0;
  }
  &.router-link-active {
    color: var(--c-primary);
  }
}

.icons {
  position: relative;
  width: var(--width-icon);
  height: var(--width-icon);

  flex-shrink: 0;

  overflow: hidden;

  .slider {
    position: absolute;
    top: 0;
    left: 0;
    width: calc(var(--width-icon) * 2);
    height: var(--width-icon);

    display: flex;

    translate: var(--translate);
    @include transitions(translate);
  }
}

.icon {
  width: var(--width-icon);
  height: var(--width-icon);

  display: grid;
  place-content: center;
}
</style>
